import {Model} from './model';

export class EmailState implements Model {
  emailStateId: number;
  key: string;
  name: string;
  description: string;

  static copy(oldObj: EmailState): EmailState {
    const newObj = new EmailState();
    newObj.emailStateId = oldObj.emailStateId;
    newObj.key = oldObj.key;
    newObj.name = oldObj.name;
    newObj.description = oldObj.description;
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.emailStateId;
  }

  isNew(): boolean {
    return isNaN(this.emailStateId);
  }

  clone(): EmailState {
    return EmailState.copy(this);
  }
}
